import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import {Modal, ModalHeader, ModalBody, ModalFooter, Row, Label, Col, Input, Form} from 'reactstrap';
import LaddaButton, {ZOOM_OUT} from "react-ladda";
import PropTypes from 'prop-types';
import api from 'api';

class AnalysisShareForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      password: '',
      loading: false,
      errors: {}
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(e) {
    this.setState({
      ...this.state,
      [e.target.name]: e.target.value
    })
  }

  onSubmit(e) {
    e.preventDefault();

    this.setState({
      ...this.state,
      loading: true
    });

    api.analysis.get.sharedQuestionSummaries({
      guid: this.props.guid,
      password: this.state.password
    }).then(data => {
      this.setState({
        ...this.state,
        loading: false
      });
      this.props.handleSummaries(data.questionSummaries);
    }).catch(res => {
      this.setState({
        ...this.state,
        errors: {
          password: res.response.data.error.message
        },
        loading: false
      });
    });
  }

  render() {
    return (
      <Modal isOpen className={'modal-danger'}>
        <ModalHeader tag="h2"><FormattedMessage id="analysisShare.analysisShareForm.modalHeader" /></ModalHeader>
        <hr className="my-0" />
        <ModalBody>
          <p><FormattedMessage id="analysisShare.analysisShareForm.modalBody" /></p>
          <Form onSubmit={this.onSubmit}>
            <Row>
              <Label for="password" lg={3}><FormattedMessage id="analysisShare.analysisShareForm.password.label" /></Label>
              <Col lg={9}>
                <Input type="password" id="password" name="password" value={this.state.password} invalid={!!this.state.errors.password} onChange={this.onChange}/>
                {this.state.errors.password && <p className="help-block text-danger">{this.state.errors.password}</p>}
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <FormattedMessage id="analysisShare.analysisShareForm.button">{
            (message) => <LaddaButton
              className="btn btn-danger btn-ladda"
              loading={this.state.loading}
              data-style={ZOOM_OUT}
              onClick={this.onSubmit}
            >
              {message}
            </LaddaButton>
          }</FormattedMessage>
        </ModalFooter>
      </Modal>
    )
  }
}

AnalysisShareForm.propTypes = {
  handleSummaries: PropTypes.func.isRequired,
  guid: PropTypes.string.isRequired,
};

export default AnalysisShareForm;